import {Formik} from "formik";
import * as Yup from "yup";
import {Form} from "react-bootstrap";
import React, {Component} from "react";
import axios from "axios";
import { URL } from "../../core/config";

const usersURL = URL + "/users";

export class ResetPasswordForm extends Component {
    render() {

        const { token, navigateToLogin} = this.props;

        return (
            <div>
                <div className="container">
                    <div className="title mb-3">Reset my password</div>
                        {/* Formik component holding two variables:
                            password: new password.
                            confirmPassword: password confirmation. Value must be the same as password value. */}
                        <Formik
                            initialValues={{ password: "", confirmPassword: "" }}

                            validationSchema={Yup.object().shape({
                                password: Yup.string().min(6, 'Password must be at least 6 characters').required('Password is required'),
                                confirmPassword: Yup.string().oneOf([Yup.ref('password'), null], 'Passwords must match').required('Confirm Password is required'),
                            })}
                            onSubmit={async (values, {setSubmitting, resetForm, setStatus}) => {
                                setSubmitting(true);
                                try {
                                    // Make a POST request to the /resetpassword route

                                    await axios.post(
                                        `${usersURL}/reset-password/${token}`, {
                                        password: values.password,
                                    });

                                    //console.log('Response:', response.data);

                                    // Show success message
                                    setStatus({ success: true });
                                    // this.props.history.push('/login'); // Redirect to login page after successful password reset
                                    navigateToLogin(); // Redirect to login page after successful password reset
                                } catch (error) {
                                    console.error('Error:', error.response?.data || error.message);

                                    // Show error message
                                    setStatus({ error: error.response?.data?.error || 'Failed to reset password' });
                                } finally {
                                    setSubmitting(false);
                                }
                            }}
                        >
                            {({values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting}) => (
                                <Form onSubmit={handleSubmit} className="outlineSquareBlueLogin">

                                    {/* Input form for writing new password */}
                                    <Form.Group controlId="formPassword">
                                        <input
                                            className={`login-input ${touched.password && errors.password ? 'is-invalid' : ''}`}
                                            type="password"
                                            name="password"
                                            placeholder="NEW PASSWORD"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.password}
                                        />
                                        {touched.password && errors.password &&
                                            <div className="invalid-feedback">{errors.password}</div>}
                                    </Form.Group>

                                    {/* Input form for writing password confirmation */}
                                    <Form.Group controlId="formResetPassword">
                                        <input
                                            className={`login-input ${touched.confirmPassword && errors.confirmPassword ? 'is-invalid' : ''}`}
                                            type="password"
                                            name="confirmPassword"
                                            placeholder="CONFIRM PASSWORD"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value= {values.confirmPassword}
                                        />
                                        {touched.confirmPassword && errors.confirmPassword &&
                                            <div className="invalid-feedback">{errors.confirmPassword}</div>}
                                    </Form.Group>

                                    <div>
                                        <button className="button" disabled={isSubmitting} type="submit" value="Submit">
                                            SUBMIT
                                        </button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                </div>
            </div>
        )
    }
}
